export function toDateString(dateString: string): string {
  if (!dateString) return "";
  const date = new Date(dateString);

  const formatter = new Intl.DateTimeFormat("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return formatter?.format(date);
}
